import { Injectable, signal } from '@angular/core';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  duration: number;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;
  readonly toasts = signal<Toast[]>([]);

  success(message: string, duration = 4000): void {
    this.addToast(message, 'success', duration);
  }

  error(message: string, duration = 5000): void {
    this.addToast(message, 'error', duration);
  }

  warning(message: string, duration = 4000): void {
    this.addToast(message, 'warning', duration);
  }

  info(message: string, duration = 4000): void {
    this.addToast(message, 'info', duration);
  }

  dismiss(id: number): void {
    this.toasts.update((list) => list.filter((t) => t.id !== id));
  }

  private addToast(message: string, type: Toast['type'], duration: number): void {
    const id = this.nextId++;
    this.toasts.update((list) => [...list, { id, message, type, duration }]);

    setTimeout(() => this.dismiss(id), duration);
  }
}
